import styled, { css } from 'styled-components'

import { space, SpaceProps } from '../../themes'

export interface ContainerProps extends SpaceProps {
  centered?: boolean
}

export const Container = styled.div<ContainerProps>`
  ${space}
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${({ centered = false }) =>
    centered &&
    css`
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `}
`
